const BASE_API_URL = (process.env.REACT_APP_API_URL ?? '') + '/local/components/iek/where_to_buy/ajax.php';
const GENERICA_SPRITE_URL = '/local/templates/.default/build/img/sprite.svg';

export type Lang = 'ru' | 'en' | 'uk' | 'kz';
type Template = 'iek_redisign' | 'generica_redisign' | 'itk_redisign' | 'oni_redisign' | 'new_iek' | 'new_itk' | 'old_itk' | 'generica';

declare global {
    interface Window {
        _whereToBuySettings?: {
            template: Template;
            lang: Lang;
            site: string;
            baseRoute: string;
        };
    }
}
const TEMPLATE = window._whereToBuySettings?.template || 'new_iek';
const LANG = window._whereToBuySettings?.lang || 'ru';
const SITE = window._whereToBuySettings?.site || 'ru';
//const BASE_ROUTE = window._whereToBuySettings?.baseRoute || '/products/where_to_buy';
// Исключенные регионы на разных языках
export const EXCLUDED_REGIONS = [
    // Крым
    "Крым Республика",
    "Crimea Republic",
    "Республика Крым",
    "Republic of Crimea",
    // ЛНР
    "Луганская Народная Республика",
    "Luhansk People's Republic",
    "LPR",
    // ДНР
    "Донецкая Народная Республика",
    "Donetsk People's Republic",
    "DPR",
];

// Маппинг языков для Yandex Maps API
const YANDEX_MAPS_LANG_MAP: Record<Lang, string> = {
    ru: 'ru_RU',
    en: 'en_US',
    uk: 'uk_UA',
    kz: 'kk_KZ',
};

// Преобразование кода языка в формат Yandex Maps
export const getYandexMapsLang = (lang: Lang | string): string => {
    if (lang in YANDEX_MAPS_LANG_MAP) {
        return YANDEX_MAPS_LANG_MAP[lang as Lang];
    }
    // Для неизвестных языков используем формат lang_LANG
    return `${lang}_${lang.toUpperCase()}`;
};

export { BASE_API_URL, GENERICA_SPRITE_URL, LANG, SITE, TEMPLATE };

